import { NgTemplateOutlet } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	inject,
} from '@angular/core';

import { NzNotificationService } from 'ng-zorro-antd/notification';

import { ButtonComponent } from '@fms/ngx-layout';
import { UserActionType } from '@fms/ts-gql-types';

import { FmsCoreService } from '../../services/core.service';

@Component({
	selector: 'fms-toggle-favorite-button',
	templateUrl: 'toggle-favorite-button.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgTemplateOutlet, ButtonComponent],
})
export class FmsToggleFavoriteBtnComponent {
	@Input({ required: true }) componentId: string;
	@Input({ required: true }) actionId: string;
	@Input() mode: 'iconOnly' | 'button' = 'iconOnly';
	@Input() heightClass = 'h-6';
	@Output() toggleActionEvent = new EventEmitter<{ isFavorite: boolean }>();
	readonly #core = inject(FmsCoreService);
	readonly #notification = inject(NzNotificationService);

	get isFavorite(): boolean {
		return this.actionId !== null && this.actionId !== undefined;
	}

	toggleFavorite() {
		const newValue = !this.isFavorite;
		if (newValue) {
			this.#core
				.createUserAction({
					actionType: UserActionType.Favorite,
					componentId: this.componentId,
				})
				.subscribe(_result => this.showNotification(newValue));
		} else {
			this.#core
				.removeUserAction({
					actionId: this.actionId,
					componentId: this.componentId,
				})
				.subscribe(_result => this.showNotification(newValue));
		}
	}

	showNotification(status: boolean): void {
		this.toggleActionEvent.emit({ isFavorite: status });
		const title = status ? 'Markeret som favorit' : 'Favorit markering fjernet';
		const content = status
			? 'Du kan se alle dine favoritter under menupunktet "Favoritter"'
			: null;
		this.#notification.blank(title, content, { nzDuration: 2000 });
	}
}
